import styled from 'styled-components';
import constants from '../../../../../../core/constants';

interface IElement {
  bkgColorEnabled: string;
  bkgColorHover: string;
  bkgColorFocus: string;
  bkgColorPressed: string;
  maxWidth: string;
  minWidth: string;
  width: string;
  height: string;
  position: string;
  right: string;
  left: string;
  top: string;
  bottom: string;
  hasInteraction: boolean;
}

// MOBILE FIRST
const WrapIElement = styled.div.attrs((props: IElement) => ({
  bkgColorEnabled: props.bkgColorEnabled,
  bkgColorHover: props.bkgColorHover,
  bkgColorFocus: props.bkgColorFocus,
  bkgColorPressed: props.bkgColorPressed,
  maxWidth: props.maxWidth,
  minWidth: props.minWidth,
  width: props.width,
  height: props.height,
  position: props.position,
  top: props.top,
  right: props.right,
  left: props.left,
  bottom: props.bottom,
  hasInteraction: props.hasInteraction
}))`
  width: ${(props) => (props.width ? props.width : 'auto')};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : 'auto')};
  min-width: ${(props) => (props.minWidth ? props.minWidth : '1px')};
  height: ${(props) => (props.height ? props.height : 'auto')};
  position: ${(props) => (props.position ? props.position : 'static')};
  top: ${(props) => (props.top ? props.top : 'auto')};
  right: ${(props) => (props.right ? props.right : 'auto')};
  left: ${(props) => (props.left ? props.left : 'auto')};
  bottom: ${(props) => (props.bottom ? props.bottom : 'auto')};
  /* MOBILE FIRST */
  /* ENABLE */
  > * {
    overflow: hidden;
    -webkit-transition: background 400ms ease-in-out;
    transition: background 400ms ease-in-out;
    background: ${(props) =>
      props.bkgColorEnabled ? props.bkgColorEnabled : 'none'};
    outline: 0;
  }

  /* HOVER */

  &.interaction:hover {
    -webkit-transition: background 400ms ease-in-out;
    transition: background 400ms ease-in-out;
    background: ${(props) =>
      props.bkgColorEnabled ? props.bkgColorEnabled : 'none'};
    outline: 0;
  }

  /* FOCUS */
  > .interaction:focus {
    -webkit-transition: background 400ms ease-in-out;
    transition: background 400ms ease-in-out;
    background: ${(props) =>
      props.bkgColorEnabled ? props.bkgColorEnabled : 'none'};
    outline: 0;
  }

  /* ACTIVE */
  > .interaction:active {
    -webkit-transition: background 0ms ease-in-out;
    transition: background 0ms ease-in-out;
    background-color: ${(props) =>
      props.bkgColorPressed ? props.bkgColorPressed : 'none'};
  }

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    /* ENABLE */
    > * {
      overflow: hidden;
      -webkit-transition: background 400ms ease-in-out;
      transition: background 400ms ease-in-out;
      background: ${(props) =>
        props.bkgColorEnabled ? props.bkgColorEnabled : 'none'};
      outline: 0;
    }

    /* HOVER */
    > .interaction:hover {
      -webkit-transition: background 150ms ease-in-out;
      transition: background 150ms ease-in-out;
      background: ${(props) =>
        props.bkgColorHover ? props.bkgColorHover : 'none'};
    }

    /* FOCUS */
    > .interaction:focus {
      -webkit-transition: background 400ms ease-in-out;
      transition: background 400ms ease-in-out;
      background: ${(props) =>
        props.bkgColorFocus ? props.bkgColorFocus : 'none'};
    }

    /* ACTIVE */
    > .interaction:active {
      -webkit-transition: background 0ms ease-in-out;
      transition: background 0ms ease-in-out;
      background-color: ${(props) =>
        props.bkgColorPressed ? props.bkgColorPressed : 'none'};
    }
  }
`;

export { WrapIElement };
